import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaScheduleStatusCreate = yup.object().shape({
  description: yup
    .string()
    .required(translate('schedulesStatusModal.validation.descriptionRequired')),
  color: yup
    .string()
    .required(translate('schedulesStatusModal.validation.colorRequired')),
});

export const schemaScheduleStatusEdit = yup.object().shape({
  description: yup
    .string()
    .required(translate('schedulesStatusModal.validation.descriptionRequired')),
  color: yup
    .string()
    .required(translate('schedulesStatusModal.validation.colorRequired')),
  status: yup
    .boolean()
    .required(translate('schedulesStatusModal.validation.statusRequired')),
});
